'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var reactIntl = require('react-intl');
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
var MediumEmphasizedDarkText = require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
var ColoredMetricBar = require('./components/ColoredMetricBar/ColoredMetricBar.js');
var ColoredMetric = require('./components/ColoredMetric/ColoredMetric.js');
var styledComponents = require('./styled-components.js');

var CurrentMonthReviewsGraphic = function (props) {
    var title = props.title, promoters = props.promoters, neutrals = props.neutrals, detractors = props.detractors, npsScore = props.npsScore;
    var fm = reactIntl.useIntl().formatMessage;
    var fmBase = 'componentLib.currentMonthReviewsGraphic';
    var theme = core.useTheme();
    var barSections = [
        {
            color: theme.palette.success.dark,
            value: promoters,
            name: fm({ id: fmBase + ".promoters" }),
        },
        {
            color: theme.palette.warning.dark,
            value: neutrals,
            name: fm({ id: fmBase + ".neutrals" }),
        },
        {
            color: theme.palette.error.dark,
            value: detractors,
            name: fm({ id: fmBase + ".detractors" }),
        },
    ];
    return (React__default.createElement("div", null,
        React__default.createElement(MediumEmphasizedDarkText, { variant: 'h2' }, title !== null && title !== void 0 ? title : fm({ id: fmBase + ".currentMonth" })),
        React__default.createElement(styledComponents.Score, null, npsScore),
        React__default.createElement(styledComponents.ScoreTitle, null, fm({ id: fmBase + ".npsScore" })),
        React__default.createElement(styledComponents.BarContainer, null,
            React__default.createElement(ColoredMetricBar, { barSections: barSections })),
        React__default.createElement(styledComponents.MetricsContainer, null, barSections.map(function (section) { return (React__default.createElement(styledComponents.MetricContainer, { style: { width: '33%' }, key: section.name },
            React__default.createElement(ColoredMetric, { color: section.color, value: section.value, name: section.name }))); }))));
};

module.exports = CurrentMonthReviewsGraphic;
